<script>
export default {
  name: 'ShowInvoice',
  data() {
    return {
      invoiceId: '',
      invoice: '',
      invoiceDetail: [],
      providers: [],
      products: [],
      locations: [],
      usrs: [],
    };
  },
  methods: {
    async getInvoices(id) {
      try {
        let result = await this.$api.get(`/auth/invoices/${id}`, {
          params: {
            id: id
          }
        })
        if (result.status.toString() === "200") {
          this.invoice = result.data
          if (this.invoice === null) {
            this.invoice = ''
          } else {
            this.invoice.invoiceDate = this.invoice.invoiceDate.substring(0, 10)
          }
        }
      } catch (error) {
        this.$swal.fire({
          icon: 'error',
          title: '',
          text: 'Ha ocurrido un error obteniendo la información',
          customClass: {
            popup: 'mySwal'
          }
        })
      }
    },
    async getInvoicesDetails(id) {
      try {
        let result = await this.$api.get(`/auth/invoices/${id}/details`, {})
        if (result.status.toString() === "200") {
          this.invoiceDetail = result.data
          if (this.invoiceDetail === null) {
            this.invoiceDetail = ''
          }
        }
      } catch (error) {
        this.$swal.fire({
          icon: 'error',
          title: '',
          text: 'Ha ocurrido un error obteniendo la información',
          customClass: {
            popup: 'mySwal'
          }
        })
      }
    },
    async getProd() {
      try {
        let res = await this.$api.get("/auth/products");
        if (res.status.toString() === "200") {
          this.products = res.data
        }
      } catch (error) {
        console.log("can't get products data")
      }
    },
    async getProv() {
      try {
        let res = await this.$api.get("/auth/providers");
        if (res.status.toString() === "200") {
          this.providers = res.data
        }
      } catch (error) {
        console.log("can't get obj data")
      }
    },
    async getLocation() {
      try {
        let res = await this.$api.get("/auth/inventory/locations");
        if (res.status.toString() === "200") {
          this.locations = res.data
        }
      } catch (error) {
        console.log("can't get location data")
      }
    },
    async getUsrs() {
      try {
        let result = await this.$api.get("/auth/users")
        if (result.status.toString() === "200") {
          this.usrs = result.data
        }
      } catch (error) {
        this.$swal.fire({
          icon: 'error',
          title: '',
          text: 'Ha ocurrido un error obteniendo la informacion',
          customClass: {
            popup: 'mySwal'
          }
        })
      }
    },
    getProductById(id) {
      return this.products.find(product => product.id === id) || {}
    },
    getProviderById(id) {
      return this.providers.find(provider => provider.id === id) || {}
    },
    getLocationById(id) {
      return this.locations.find(location => location.id === id) || {}
    },
    getUserById(id) {
      return this.usrs.find(usr => usr.id === id) || {}
    },
  },
  created() {
    this.invoiceId = this.$route.params.id;
    this.getInvoices(this.invoiceId)
    this.getInvoicesDetails(this.invoiceId)
    this.getProv()
    this.getProd()
    this.getLocation()
    this.getUsrs()
  }
}

</script>

<template>
  <h1>Factura</h1>
  <p>{{ invoice.code }} - {{ getProviderById(invoice.provider).name }}</p>
  <div class="grid-container"
       style="padding-top: 40px; padding-left: 40px; padding-bottom: 40px; background-color: rgba(39, 51, 116, 0.1); border-radius: 30px;">
    <!-- Column 1 -->
    <div style="text-align: left;">
      <label>Registrado por:</label>
      <p>{{ getUserById(invoice.usr).firstname }} {{ getUserById(invoice.usr).lastname }}</p>

      <label>F01:</label>
      <p>{{ invoice.f01 }}</p>

      <label>Fecha:</label>
      <p>{{ invoice.invoiceDate }}</p>

      <label>Subtotal:</label>
      <p>{{ invoice.grossCost }}</p>
    </div>

    <div style="text-align: left">
      <label>Ingresado a:</label>
      <p>{{ getLocationById(invoice.location).name }}</p>

      <label>Orden de compra:</label>
      <p>{{ invoice.purchaseOrder }}</p>

      <label>Total:</label>
      <p>{{ invoice.netCost }}</p>

      <label>Impuestos:</label>
      <p>{{ invoice.taxes }}</p>
    </div>
  </div>

  <div class="container mt-4 table-container" style="margin-top: 40px">
    <table id="myTable">
      <thead>
      <tr>
        <th>#</th>
        <th>Producto</th>
        <th>Cantidad</th>
        <th>Precio Unitario</th>
        <th>Subtotal</th>
        <th>Impuestos</th>
        <th>Expira</th>
        <th>Codigo de barras</th>
        <th>Lote</th>
      </tr>

      </thead>
      <tbody>
      <tr v-for="(product, index) in invoiceDetail" :key="index">
        <th scope="row">{{ index + 1 }}</th>
        <td>{{ getProductById(product.product).title }}</td>
        <td>{{ product.quantity }}</td>
        <td>{{ product.unitCost }}</td>
        <td>{{ product.grossCost }}</td>
        <td>{{ product.taxes }}</td>
        <td>{{ product.expires.substring(0, 4) === "0000" ? '' : product.expires.substring(0, 10)  }}</td>
        <td>{{product.barcode}}</td>
        <td>{{product.itemBatch}}</td>
      </tr>
      </tbody>
    </table>

  </div>

</template>

<style>


</style>